<template>
  <documents-delete-table-component
    :headings="headings"
    :documents="documents"
    :actionItems="reviewResults">
    <review-actions-component
      slot-scope="{ actionItem }"
      :result="actionItem"
      v-on:openCommentSection="$emit('openCommentSection', actionItem)"
      v-on:stateOK="$emit('stateOK', actionItem)"
      v-on:stateNotOK="$emit('stateNotOK', actionItem)"
      v-on:statePENDING="$emit('statePENDING', actionItem)">
    </review-actions-component>
  </documents-delete-table-component>
</template>
<script>
  import { ReviewResult } from '@/classes/case/ReviewResult'
  import { Document } from '@/classes/case/Document'
  import ReviewActionsComponent from '@/components/layout/case_review/ReviewActionsComponent'
  import DocumentsDeleteTableComponent from '@/components/layout/utility/DocumentsDeleteTableComponent'

  export default {
    name: 'review-documents-component',
    components: {
      ReviewActionsComponent,
      DocumentsDeleteTableComponent
    },
    data () {
      return {
        headings: {
          col1: { name: 'Documents', classes: 'is-3-tablet is-4-desktop' },
          col2: { name: 'Filename', classes: 'is-3-tablet is-4-desktop' },
          col3: { name: 'Uploaded', classes: 'is-3-tablet is-2-desktop' },
          col4: { name: '', classes: 'is-3-tablet is-2-desktop' }
        }
      }
    },
    props: {
      reviewResults: {
        type: Array,
        validator: (prop) => prop.every(e => e instanceof ReviewResult),
        required: true
      }
    },
    computed: {
      documents () {
        return this.reviewResults.map(result => {
          return new Document(result.getLabel(), result.value)
        })
      }
    }
  }
</script>
<style lang="sass" scoped>
</style>
